import { useState, useEffect } from 'react';
import { useAppSelector } from '../../../app/hooks';

import { isViewer } from '../../../utils/userPermissions';

export const useIsViewer = () => {
  const [isViewerStatus, setIsViewerStatus] = useState(false);
  const { user } = useAppSelector((state) => state.auth);

  useEffect(() => {
    if (!user) setIsViewerStatus(false);
    else setIsViewerStatus(isViewer(user.role));
  }, [user]);

  return isViewerStatus;
};
